import { useState } from 'react';

export interface PoorStandingControllerType {
    isPoorStandingVisible: boolean;
    showPoorStanding: (newState: boolean) => void;
}

export const usePoorStandingContextController =
    (): PoorStandingControllerType => {
        const [isPoorStandingVisible, setIsPoorStandingVisible] =
            useState(false);

        const showPoorStanding = (newState: boolean) => {
            setIsPoorStandingVisible(newState);
        };

        return {
            isPoorStandingVisible,
            showPoorStanding,
        };
    };
